"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
/**
 * An implementation of {@link EntityDefault} class. It is just a consumer type serving as a basic, default
 * implementation without any significant added value.
 * @class
 * @extends {EntityDefault}
 */
var SubEntity = /** @class */ (function (_super) {
    __extends(SubEntity, _super);
    function SubEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @override
     * @returns {MainEntity}
     */
    SubEntity.prototype.clone = function () {
        return this.cloneEntity(SubEntity);
    };
    return SubEntity;
}(idm_de_core_frontend_1.EntityDefault));
exports.SubEntity = SubEntity;
//# sourceMappingURL=sub-entity.model.js.map